const entity = {
    formulario : [{
        name: 'Pagos',
        groups: [
          {
            title: '',
            size: { xs: 12, sm: 12, md: 12 },
            display: true,
            fields: [
              {
                id: 'amount',
                label: 'Monto',
                kind: 'number',
                required: true,
                size: { xs: 12, sm: 12, md: 12 }
              },
              {
                id: 'comments',
                label: 'nota',
                kind: 'textarea',
                required: true,
                size: { xs: 12, sm: 12, md: 12 }
              }
            ],
          }
        ],
      }]
}

export default entity;